import { getCustomerRevenueData } from "./getCustomerRevenueData"

/**
 * Enriches an array of customers with additional data.
 *
 * @param {Array} customers - The array of customers to be enriched.
 * @param {boolean} includeRevenue - Whether to include revenue data.
 * @param {Array} branchOffices - The branch offices with id and title.
 * @returns {Array} - The enriched array of customers.
 */
export const enrichCustomers = (customers, includeRevenue = false, branchOffices) => {
  return customers.map(async (result) => {
    const { custom: customFields, defaultBillingAddressId, addresses, customerNumber } = result

    let currentYearRevenueData = null
    if (includeRevenue) {
      const { currentYearRevenue } = await getCustomerRevenueData(customerNumber)
      currentYearRevenueData = currentYearRevenue
    }

    const branchId = customFields?.fields?.deliveryBranch ?? customFields?.fields?.customerBranch

    const branchTitle = branchOffices?.find((branch) => branch?.id === branchId)?.title || ""

    return {
      ...result,
      customFields: {
        customerBranchId: branchId,
        customerClassification: customFields?.fields?.customerClassification ?? null,
        tourNumber: customFields?.fields?.tourNumber ?? null,
        matchCode: customFields?.fields?.matchCode ?? null,
        einzaCreditLimit: customFields?.fields?.einzaCreditLimit ?? null,
        currentYearRevenueData: currentYearRevenueData ?? null,
        branchTitle,
      },
      defaultBillingAddress: addresses.find((address) => address?.id === defaultBillingAddressId) ?? null,
    }
  })
}
